/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
import { createMuiTheme } from '@material-ui/core/styles';
import { red, green, amber, cyan, grey, } from '@material-ui/core/colors';
const maestro = (type) => ({
    typography: {
        fontFamily: ['Montserrat', 'sans-serif'].join(','),
        fontSize: 14,
    },
    palette: {
        type,
        primary: {
            tint: 'rgb(242, 252, 239)',
            light: type === 'dark' ? 'rgb(151, 228, 127)' : 'rgb(122, 217, 95)',
            main: type === 'dark' ? 'rgb(122, 217, 95)' : 'rgb(102, 175, 78)',
            dark: type === 'dark' ? 'rgb(102, 175, 78)' : 'rgb(77, 150, 53)',
            contrastText: type === 'dark' ? '#000000de' : '#ffffff',
        },
        secondary: {
            tint: 'rgb(244, 242, 237)',
            light: 'rgb(224, 222, 208)',
            main: 'rgb(217, 213, 197)',
            dark: 'rgb(191, 189, 167)',
            // contrastText: theme.palette.text.primary
        },
        alternative: {
            tint: 'rgb(244 232 255)',
            light: 'rgb(171 146 194)',
            main: 'rgb(150, 119, 179)',
            dark: 'rgb(105 83 125)',
            contrastText: '#ffffff',
        },
        default: {
            tint: 'rgb(242, 252, 239)',
            light: type === 'dark' ? 'rgb(151, 228, 127)' : 'rgb(122, 217, 95)',
            main: type === 'dark' ? 'rgb(122, 217, 95)' : 'rgb(102, 175, 78)',
            dark: type === 'dark' ? 'rgb(102, 175, 78)' : 'rgb(77, 150, 53)',
            contrastText: type === 'dark' ? '#000000de' : '#ffffff',
        },
        success: {
            tint: 'rgb(242, 252, 239)',
            light: type === 'dark' ? 'rgb(151, 228, 127)' : 'rgb(122, 217, 95)',
            main: type === 'dark' ? 'rgb(122, 217, 95)' : 'rgb(102, 175, 78)',
            dark: type === 'dark' ? 'rgb(102, 175, 78)' : 'rgb(77, 150, 53)',
            contrastText: type === 'dark' ? '#000000de' : '#ffffff',
        },
        info: {
            tint: 'rgb(244 255 255)',
            light: 'rgb(177, 233, 233)',
            main: 'rgb(158, 228, 228)',
            dark: 'rgb(110, 159, 159)',
            // contrastText: theme.palette.text.primary
        },
        warning: {
            tint: 'rgb(255, 251, 241)',
            light: 'rgb(250, 209, 95)',
            main: 'rgb(249, 198, 55)',
            dark: 'rgb(174, 138, 38)',
            // contrastText: theme.palette.text.primary
        },
        error: {
            tint: 'rgb(255, 175, 175)',
            light: 'rgb(243, 111, 111)',
            main: 'rgb(212, 42, 42)',
            dark: 'rgb(198, 15, 15)',
            // contrastText: theme.palette.text.primary
        },
        none: {
            tint: 'rgb(244, 242, 237)',
            light: 'rgb(224, 222, 208)',
            main: 'rgb(217, 213, 197)',
            dark: 'rgb(191, 189, 167)',
            // contrastText: theme.palette.text.primary
        },
    },
});
const michelin = (type, options) => {
    const theme = createMuiTheme(Object.assign({ typography: {
            fontFamily: ['Montserrat', 'sans-serif'].join(','),
            fontSize: 14,
        } }, options));
    theme.palette.primary = theme.palette.augmentColor({ main: 'rgba(39, 80, 155, 1)' });
    theme.palette.secondary = theme.palette.augmentColor({ main: 'rgba(252, 229, 0, 1)' });
    theme.palette.default = theme.palette.augmentColor({ main: 'rgba(4, 145, 210, .8)' });
    theme.palette.success = theme.palette.augmentColor({ main: green[500] });
    theme.palette.warning = theme.palette.augmentColor({ main: amber[500] });
    theme.palette.info = theme.palette.augmentColor({ main: cyan[500] });
    theme.palette.error = theme.palette.augmentColor({ main: red[500] });
    theme.palette.disabled = theme.palette.augmentColor({ main: grey[500] });
    theme.palette.none = theme.palette.augmentColor({ main: grey[300] });
    theme.palette.success.contrastText = 'rgba(255, 255, 255, 1)';
    theme.palette.info.contrastText = 'rgba(255, 255, 255, 1)';
    theme.palette.warning.contrastText = theme.palette.text.primary;
    theme.palette.none.contrastText = theme.palette.text.primary;
    theme.palette.primary.tint = 'rgba(39, 80, 155, .1)';
    theme.palette.secondary.tint = 'rgba(252, 229, 0, .3)';
    theme.palette.default.tint = 'rgba(4, 145, 210, .1)';
    theme.palette.success.tint = green[50];
    theme.palette.warning.tint = amber[50];
    theme.palette.info.tint = cyan[50];
    theme.palette.error.tint = red[50];
    theme.palette.disabled.tint = grey[50];
    theme.palette.none.tint = grey[50];
    return theme;
};
function createTheme(options) {
    const type = (options && options.palette && options.palette.type) || 'light';
    if (options && options.palette && options.palette.type) {
        if (Object.keys(options.palette).length === 1) {
            delete options.palette;
        }
        else {
            delete options.palette.type;
        }
    }
    const theme = (type === 'michelin') ? michelin(type, options) : createMuiTheme(Object.assign(Object.assign({}, maestro(type)), options));
    theme.palette.danger = theme.palette.error;
    theme.logo = {};
    theme.logo.maestro = {};
    theme.logo.poweredBy = {};
    theme.logo.michelin = {};
    return theme;
}
export default createTheme;
//# sourceMappingURL=createTheme.js.map